import { writable } from 'svelte/store';
export var CommentFilterByBookmarkMode;
(function (CommentFilterByBookmarkMode) {
    CommentFilterByBookmarkMode["NONE"] = "\u0412\u044B\u043A\u043B.";
    CommentFilterByBookmarkMode["MY"] = "\u0422\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0438 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438";
    // GROUP = "group",
})(CommentFilterByBookmarkMode || (CommentFilterByBookmarkMode = {}));
const DEFAULT_COMMENT_SOURCES_CONFIG = {
    "torah": {
        filterBySource: {},
        filterByBookmarkMode: CommentFilterByBookmarkMode.NONE,
        sourcesOrder: [],
    },
    "neviim": {
        filterBySource: {},
        filterByBookmarkMode: CommentFilterByBookmarkMode.NONE,
        sourcesOrder: [],
    }
};
export const commentSourcesConfigStore = writable(DEFAULT_COMMENT_SOURCES_CONFIG);
const LOCAL_STORAGE_KEY = 'commentFilters';
function load() {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved === null)
        return DEFAULT_COMMENT_SOURCES_CONFIG;
    else {
        return JSON.parse(saved);
    }
}
function save(current) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(current));
}
export function initCommentSourcesConfig(metadata) {
    let config = load();
    // migration from single-section metadata
    if (config.filterByBookmarkMode !== undefined) {
        config = {
            // @ts-expect-error
            torah: Object.assign({}, config),
            neviim: DEFAULT_COMMENT_SOURCES_CONFIG.neviim
        };
    }
    // ensuring the config is complete and resetting things to default if necessary
    for (const [key, sectionConfig] of Object.entries(config)) {
        const sectionKey = key;
        const allSectionCommentSourceKeys = metadata.sections[sectionKey].comment_sources.map(cs => cs.key);
        for (const commentSource of allSectionCommentSourceKeys) {
            if (sectionConfig.filterBySource[commentSource] === undefined) {
                sectionConfig.filterBySource[commentSource] = true;
            }
        }
        if (sectionConfig.sourcesOrder === undefined || sectionConfig.sourcesOrder.length != allSectionCommentSourceKeys.length) {
            sectionConfig.sourcesOrder = allSectionCommentSourceKeys;
        }
    }
    commentSourcesConfigStore.set(config);
    save(config);
}
export function toggleCommentFilterBySource(sectionKey, commentSource) {
    commentSourcesConfigStore.update(config => {
        if (config[sectionKey].filterBySource[commentSource] === undefined) {
            return config;
        }
        else {
            config[sectionKey].filterBySource[commentSource] = !config[sectionKey].filterBySource[commentSource];
            save(config);
            return config;
        }
    });
}
export function setCommentFilterBySource(sectionKey, bySource) {
    commentSourcesConfigStore.update(config => {
        config[sectionKey].filterBySource = bySource;
        save(config);
        return config;
    });
}
export function setCommentFilterByBookmarkMode(sectionKey, mode) {
    commentSourcesConfigStore.update(config => {
        config[sectionKey].filterByBookmarkMode = mode;
        save(config);
        return config;
    });
}
export function swapElementsInSourceOrder(sectionKey, oldIndex, newIndex) {
    commentSourcesConfigStore.update(config => {
        let sourcesOrder = [...config[sectionKey].sourcesOrder];
        const el = sourcesOrder[oldIndex];
        console.log(`Moving ${el} ${oldIndex} -> ${newIndex}; before: ${sourcesOrder}`);
        sourcesOrder.splice(oldIndex, 1);
        sourcesOrder.splice(newIndex, 0, el);
        console.log(`...after: ${sourcesOrder}`);
        config[sectionKey].sourcesOrder = [...sourcesOrder];
        save(config);
        return config;
    });
}
